import React, {useEffect,useState} from 'react'
import {fetchAllNews, newsSelector} from '../../api/news'
import {loginSelector} from '../../api/authSlice'
import {useDispatch, useSelector} from 'react-redux'
import Loader from '../../shared/loader'
import DataTable from './datatable'
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { Input  } from 'antd';
import { useDebounce } from "use-debounce";


export default function News() {

  const dispatch = useDispatch()
  const {news } = useSelector(newsSelector)
  const {filter} = useSelector(loginSelector)
  console.log(filter);
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(false)
  const [debouncedText] = useDebounce(search, 1000)

  console.log({news})

useEffect(()=>{
dispatch(fetchAllNews())
}, [dispatch])

const { Search } = Input;




    return (<>
<div className="mb-4 float-right ">
    <div className="mx-3">

{/* <Search placeholder="Search News" className="mx-3" style={{ width: 230 }} enterButton /> */}
    <Button type="primary">
        <Link className = " text-white" to="/admin/create-news">Add News</Link>
    </Button> 
</div>
</div>
{

 <DataTable loading={loading}
 data ={(filter.length> 0) ? filter : news}/>

}
    </>
       )
}  







